import strings from './strings';

const getStringsByLanguage = (strings, ...rest) => {
  const language = rest.length > 0 && rest[0] !== undefined ? rest[0] : 'en';
  return Object.entries(strings).reduce(function (acc, curr) {
    acc[curr[0]] = curr[1][language];
    return acc;
  }, {});
};

const stringsReducer = (state = getStringsByLanguage(strings), action) => {
  switch (action.type) {
    case 'SET_LANGUAGE':
      return getStringsByLanguage(strings, action.resp);
    default:
      return state;
  }
};

export default stringsReducer;
